export default __webpack_public_path__ + "static/media/image 5-2.ca20a2e7.png";